<template>
  <section class="detail pt-50 pb-20">
    <div class="container">
      <div class="row">
        <div class="col-xl-12">
          <div class="detail__title">
            <h2 v-if="id == 33">
              Công ty Đấu giá Hợp danh Tân Đại Phát mời {{ detail.TenKeHoach }}
            </h2>
            <h2 v-else>{{ detail.TenKeHoach }}</h2>
          </div>
        </div>
        <div class="col-lg-12 col-md-12">
          <div class="detail-tab">
            <!--Nav Button  -->
            <nav>
              <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a
                  class="nav-item nav-link"
                  v-bind:class="{ 'active show': tab == 1 }"
                  id="nav-1-tab"
                  data-toggle="tab"
                  role="tab"
                  aria-controls="nav-1"
                  aria-selected="true"
                  v-on:click="tab = 1"
                  >Thông tin cuộc đấu giá</a
                >
                <a
                  class="nav-item nav-link"
                  v-bind:class="{ 'active show': tab == 2 }"
                  id="nav-2-tab"
                  data-toggle="tab"
                  role="tab"
                  aria-controls="nav-2"
                  aria-selected="false"
                  v-on:click="tab = 2"
                  >Chi tiết sản phẩm</a
                >
                <a
                  class="nav-item nav-link"
                  v-bind:class="{ 'active show': tab == 3 }"
                  id="nav-3-tab"
                  data-toggle="tab"
                  role="tab"
                  aria-controls="nav-3"
                  aria-selected="false"
                  v-on:click="tab = 3"
                  >Hồ sơ tham gia đấu giá</a
                >
              </div>
            </nav>
            <!--End Nav Button  -->
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="tab-content" id="nav-tabContent">
            <!-- card one -->
            <div
              v-if="tab == 1"
              class="tab-pane fade"
              v-bind:class="{ 'active show': tab == 1 }"
              id="nav-1"
              role="tabpanel"
              aria-labelledby="nav-1-tab"
            >
              <div class="row">
                <!--Image Detail-->
                <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12">
                  <div class="detail__img">
                    <carousel
                      :paginationPosition="'bottom-overlay'"
                      :per-page="1"
                      :autoplay="true"
                      :loop="true"
                      :autoplayTimeout="3000"
                    >
                      <slide
                        data-index="0"
                        v-for="i in detail.TaiSanDauGia[0].DinhKem"
                        :key="i"
                        style="width: 100%; height: 350px;"
                      >
                        <img
                          v-gallery:groupName
                          style="cursor: zoom-in;border-radius: 3px;object-fit: cover;width: 100%;min-height: 100%;"
                          :src="i.LinkDownload"
                        />
                      </slide>
                    </carousel>
                  </div>
                </div>
                <!--End Detail-->
                <!--Info Detail-->
                <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12">
                  <div class="detail__info">
                    <div class="detail__row">
                      <span v-if="id == 33"
                        >Công ty Đấu giá Hợp danh Tân Đại Phát mời đấu giá
                        {{ detail.MoTaTomTat }}</span
                      >
                      <span v-else>{{ detail.MoTaTomTat }}</span>
                    </div>
                    <div class="detail__row">
                      <span class="detail__label txt-main"
                        >Người có tài sản:</span
                      >
                      <span class="detail__value">{{
                        detail.NguoiBanDauGia
                      }}</span>
                    </div>
                    <div class="detail__row">
                      <span class="detail__label txt-main">Ngày công bố:</span>
                      <!-- <span class="detail__value">{{detail.NgayCongBo | formatDate}}</span> -->
                      <span class="detail__value">{{
                        detail.NgayCongBo | formatDateNgay
                      }}</span>
                    </div>
                    <div class="detail__row">
                      <span class="detail__label txt-main"
                        >Hạn đăng ký từ:</span
                      >
                      <span class="detail__value">{{
                        detail.HanDangKyBatDau | formatDate
                      }}</span>
                    </div>
                    <div class="detail__row">
                      <span class="detail__label txt-main"
                        >Hạn đăng ký đến:</span
                      >
                      <span class="detail__value">{{
                        detail.HanDangKyKetThuc | formatDate
                      }}</span>
                    </div>
                    <div class="detail__row">
                      <span class="detail__label txt-main"
                        >Thời gian bắt đầu cuộc đấu giá:</span
                      >
                      <span class="detail__value">{{
                        detail.BatDau | formatDate
                      }}</span>
                    </div>
                    <div class="detail__row">
                      <span class="detail__label txt-main"
                        >Thời gian kết thúc cuộc đấu giá:</span
                      >
                      <span
                        class="detail__value"
                        v-if="detail.KhoangThoiGianMoRong == 0"
                        >{{ detail.KetThuc | formatDate }}</span
                      >
                      <span
                        class="detail__value"
                        v-if="detail.KhoangThoiGianMoRong > 0"
                        >Theo quy chế cuộc đấu giá</span
                      >
                    </div>
                    <!-- <div class="detail__row">
                                       <span class="detail__label txt-main">Thời gian điểm danh người tham gia đấu giá:</span>
                                       <span class="detail__value">{{detail.ThoiGianDiemDanhThamGiaDauGia}}</span>
                                    </div> -->
                    <div class="detail__row" v-if="detail.ChoPhepDiXemTaiSan">
                      <span class="detail__label txt-main"
                        >Ngày đến xem tài sản:</span
                      >
                      <span class="detail__value">{{
                        detail.NgayDenXemTaiSan | formatDateViewAssets
                      }}</span>
                    </div>
                    <div class="detail__row">
                      <!-- <span class="detail__label txt-main" v-if="detail.TypeId==1">Giá khởi điểm/m2:</span>
                                       <span class="detail__label txt-main" v-if="detail.TypeId==0">Giá khởi điểm:</span> -->
                      <span class="detail__label txt-main">Giá khởi điểm:</span>
                      <span class="detail__value"
                        >{{ detail.GiaKhoiDiem.toLocaleString("da-DK") }}
                        {{ detail.DonViTinh }}</span
                      >
                    </div>
                    <div class="detail__row">
                      <!-- <span class="detail__label txt-main" v-if="detail.TypeId==1">Bước giá/m2:</span>
                                       <span class="detail__label txt-main" v-if="detail.TypeId==0">Bước giá:</span> -->
                      <span class="detail__label txt-main">Bước giá:</span>
                      <span class="detail__value"
                        >{{ detail.BuocGia.toLocaleString("da-DK") }}
                        {{ detail.DonViTinh }}</span
                      >
                    </div>
                    <div class="detail__row">
                      <span class="detail__label  txt-main"
                        >Chi phí tham gia đấu giá:</span
                      >
                      <span class="detail__value"
                        >{{ detail.PhiThamGiaDauGia.toLocaleString("da-DK") }}
                        {{ detail.DonViTinh }}</span
                      >
                    </div>
                    <div class="detail__row">
                      <span class="detail__label  txt-main"
                        >Tiền đặt trước:</span
                      >
                      <span class="detail__value"
                        >{{ detail.SoTienDatCoc.toLocaleString("da-DK") }}
                        {{ detail.DonViTinh }}</span
                      >
                    </div>
                    <!-- <div class="detail__row">
                                       <span>Thời gian kết thúc cuộc đấu giá theo quy định tại Quy chế cuộc đấu giá</span>
                                    </div> -->
                    <div class="detail__row" v-if="isRegister">
                      <span class="detail__label  txt-main"
                        >Đăng ký đấu giá:</span
                      >
                      <span class="detail__value">Đã duyệt</span>
                    </div>
                    <div class="detail__row" v-else-if="isRejected">
                      <span class="detail__label  txt-main"
                        >Đăng ký đấu giá:</span
                      >
                      <span class="detail__value">Bị từ chối</span>
                    </div>
                    <div class="detail__row">
                      <template v-if="detail.ChoPhepRutDangKy">
                        <button
                          v-if="isWatting && status == 1"
                          v-on:click="removeRegisterAuction"
                          class="detail__btn"
                          style="background: crimson;"
                        >
                          Rút đăng ký đấu giá
                        </button>
                      </template>
                      <template v-else>
                        <button
                          v-if="isRegister && status == 1"
                          class="detail__btn"
                          style="background: #007bff;"
                        >
                          Đã duyệt
                        </button>
                      </template>

                      <button
                        v-if="isWatting && status == 2"
                        class="detail__btn"
                        style="color: #fff;background-color: #4dbd74;"
                        disabled
                      >
                        Chờ phê duyệt
                      </button>
                      <button
                        v-if="
                          hasPermissionRegister &&
                            status == 1 &&
                            !isRegister &&
                            isAuthenticated &&
                            !isWatting &&
                            !isRejected
                        "
                        v-on:click="$modal.show('modal-register-auction')"
                        class="detail__btn"
                        style="color: #fff;background-color: #4dbd74;"
                      >
                        Đăng ký tham gia đấu giá
                      </button>
                      <button
                        v-else-if="status == 4"
                        class="detail__btn"
                        style="color: #fff;background-color: #f63c3a;"
                      >
                        Cuộc đấu giá đã kết thúc
                      </button>
                      <button
                        v-if="!isAuthenticated && status != 4"
                        class="detail__btn"
                        style="background-color: #20a8d8;"
                      >
                        Vui lòng đăng nhập để đăng ký đấu giá
                      </button>
                    </div>
                  </div>
                </div>
                <!--End Info Detail-->
              </div>
            </div>
            <!-- end card one -->
            <!-- card two -->
            <div
              v-else-if="tab == 2"
              class="tab-pane fade"
              v-bind:class="{ 'active show': tab == 2 }"
              id="nav-2"
              role="tabpanel"
              aria-labelledby="nav-2-tab"
            >
              <div class="row">
                <!--Image Detail-->
                <div class="col-xl-12">
                  <div
                    class="detail__des"
                    v-html="detail.TaiSanDauGia[0].MoTaChiTiet"
                  ></div>
                </div>
                <!--End Detail-->
              </div>
            </div>
            <!-- end card two -->
            <!-- card 3 -->
            <div
              v-else-if="tab == 3"
              class="tab-pane fade"
              v-bind:class="{ 'active show': tab == 3 }"
              id="nav-3"
              role="tabpanel"
              aria-labelledby="nav-3-tab"
            >
              <div class="row">
                <!--Image Detail-->
                <div class="col-xl-12">
                  <div
                    class="detail__history"
                    v-html="detail.VanBanPhapLy"
                  ></div>
                </div>
                <!--End Detail-->
              </div>
            </div>
            <!-- end card 3 -->
          </div>
        </div>
      </div>
    </div>
    <modal
      :adaptive="true"
      :resizable="true"
      name="modal-register-auction"
      height="auto"
      :scrollable="true"
    >
      <form
        action=""
        method="post"
        class=""
        style="padding: 20px;padding-bottom: 70px;padding-top: 50px;"
      >
        <div slot="top-right" style="float: right;">
          <a
            type="button"
            class=""
            @click="$modal.hide('modal-register-auction')"
          >
            ❌
          </a>
        </div>
        <div class="">
          <h5>Đăng ký tham gia đấu giá</h5>
        </div>
        <div
          class=""
          style="border-top: 1px solid #00000059;margin-top: 5px;padding-top: 5px;font-weight: bold;"
        >
          <span>Số tiền cần phải nộp</span>
        </div>
        <form>
          <div class="form-group row">
            <label
              for="staticEmail"
              class="col-sm-4 col-form-label col-form-label-sm"
              >Chi phí tham gia đấu giá</label
            >
            <div class="col-sm-8">
              <input
                type="text"
                disabled
                :value="detail.PhiThamGiaDauGia.toLocaleString('da-DK')"
                class="input-modal form-control-sm form-control-plaintext"
              />
            </div>
          </div>
        </form>
        <form>
          <div class="form-group row">
            <label
              for="staticEmail"
              class="col-sm-4 col-form-label col-form-label-sm"
              >Số tiền đặt trước</label
            >
            <div class="col-sm-8">
              <input
                type="text"
                disabled
                :value="detail.SoTienDatCoc.toLocaleString('da-DK')"
                class="input-modal form-control-sm form-control-plaintext"
              />
            </div>
          </div>
        </form>
        <form>
          <div class="form-group row">
            <label
              for="staticEmail"
              class="col-sm-4 col-form-label col-form-label-sm"
              >Tổng tiền</label
            >
            <div class="col-sm-8">
              <input
                type="text"
                disabled
                :value="
                  (
                    detail.SoTienDatCoc + detail.PhiThamGiaDauGia
                  ).toLocaleString('da-DK')
                "
                class="input-modal form-control-sm form-control-plaintext"
              />
            </div>
          </div>
        </form>
        <form>
          <div class="form-group row">
            <label
              for="staticEmail"
              class="col-sm-4 col-form-label col-form-label-sm"
              >Bằng chữ</label
            >
            <div class="col-sm-8">
              <input
                type="text"
                disabled
                :value="docso(detail.SoTienDatCoc + detail.PhiThamGiaDauGia)"
                class="input-modal form-control-sm form-control-plaintext"
              />
            </div>
          </div>
        </form>
        <div
          class=""
          style="border-top: 1px solid #00000059;margin-top: 5px;padding-top: 5px;font-weight: bold;"
        >
          <span>Thông tin nhận lại khoản tiền đặt trước</span>
        </div>
        <form>
          <div class="form-group row">
            <label
              for="staticEmail"
              class="col-sm-4 col-form-label col-form-label-sm"
              >Số tài khoản</label
            >
            <div class="col-sm-8">
              <input
                type="number"
                v-model="bank.number"
                class="input-modal form-control-sm form-control-plaintext"
              />
            </div>
          </div>
        </form>
        <form>
          <div class="form-group row">
            <label
              for="staticEmail"
              class="col-sm-4 col-form-label col-form-label-sm"
              >Ngân hàng</label
            >
            <div class="col-sm-8">
              <input
                type="text"
                style="text-transform: unset;"
                v-model="bank.name"
                class="input-modal form-control-sm form-control-plaintext"
              />
            </div>
          </div>
        </form>
        <form>
          <div class="form-group row">
            <label
              for="staticEmail"
              class="col-sm-4 col-form-label col-form-label-sm"
              >Chủ tài khoản</label
            >
            <div class="col-sm-8">
              <input
                type="text"
                style="text-transform: uppercase;"
                v-model="bank.user"
                class="input-modal form-control-sm form-control-plaintext"
              />
            </div>
          </div>
        </form>
        <span v-if="messModal != ''" style="color: red">{{ messModal }}</span>
        <div class="row">
          <template v-if="detail.ChoPhepDiXemTaiSan">
            <div class="col-md-12">
              <form
                style="padding-top: 7px;"
                name="header-search-form"
                method="GET"
                class=""
              >
                <input
                  type="radio"
                  value="1"
                  v-model="picked"
                  class="input-modal"
                  style="margin-right: 10px;"
                />Đăng ký đi xem hiện trạng tài sản đấu giá
              </form>
            </div>
            <div class="col-md-12">
              <form name="header-search-form" method="GET" class="">
                <input
                  type="radio"
                  value="0"
                  v-model="picked"
                  class="input-modal"
                  style="margin-right: 10px;"
                />Không đăng ký đi xem hiện trạng tài sản đấu giá và cam kết
                không khiếu nại về hiện trạng tài sản
              </form>
            </div>
          </template>
          <div class="col-md-12">
            <form
              style="padding-top: 7px;"
              name="header-search-form"
              method="GET"
              class=""
            >
              <input
                type="checkbox"
                v-model="check"
                class="input-modal"
                style="margin-right: 10px;"
              />Tôi đã đọc và nghiên cứu đầy đủ các thông tin của hồ sơ tham dự
              đấu giá. Tôi cam kết thực hiện đúng các quy định trong hồ sơ và
              quy định pháp luật liên quan
            </form>
          </div>
          <button
            :disabled="!check"
            type="button"
            v-on:click="registerAuction"
            style="color: #fff;background-color: #007bff;border-color: #007bff;padding: .25rem .5rem;font-size: .875rem;line-height: 1.5;border-radius: .2rem;"
            class="btn btn-primary btn-lg btn-block"
          >
            Đăng ký tham gia đấu giá
          </button>
        </div>
        <div class="wpcf7-response-output wpcf7-display-none"></div>
      </form>
    </modal>
  </section>
</template>

<script>
import mixin from "@/mixins/mixin.js";
import { mapGetters } from "vuex";
import timeDotGov from "@/common/api/time";
import moment from "moment";
import Auction from "@/common/api/auction";
import { Money } from "v-money";
import { Carousel, Slide } from "vue-carousel";
const mangso = [
  "không",
  "một",
  "hai",
  "ba",
  "bốn",
  "năm",
  "sáu",
  "bảy",
  "tám",
  "chín"
];
export default {
  components: { Carousel, Slide },
  mixins: [mixin],
  name: "ProductDetail",
  props: ["id"],
  mixins: ["utils"],
  data() {
    return {
      hasPermissionRegister: true,
      picked: "0",
      status: -1,
      bank: {
        number: "",
        name: "",
        user: ""
      },
      check: false,
      detail: {},
      tab: 1,
      isRegister: false,
      isWatting: false,
      isRejected: false,
      messModal: ""
    };
  },
  filters: {
    formatDateViewAssets: function(value) {
      var new_date = moment(String(value)).add(1, "days");
      if (!value) return "";
      return (
        "Từ " +
        moment(String(value)).format("DD/MM/YYYY") +
        " đến " +
        new_date.format("DD/MM/YYYY")
      );
    },
    formatDate: function(value) {
      if (!value) return "";
      return moment(String(value)).format("HH:mm:ss DD/MM/YYYY");
    },
    formatDateNgay: function(value) {
      if (!value) return "";
      return moment(String(value)).format("DD/MM/YYYY");
    }
  },
  created() {
    this.getDetail();
    if (this.currentUser.permissions.length > 0) {
      this.hasPermissionRegister = false;
    } else {
      this.checkRegister();
    }
  },
  mounted() {},
  computed: {
    ...mapGetters(["currentTime", "currentUser", "isAuthenticated"])
  },
  methods: {
    removeRegisterAuction() {
      this.$swal
        .fire({
          title: "Rút đăng ký đấu giá!",
          text:
            "Người rút đăng ký tham gia đấu giá không được hoàn trả chi phí tham gia đấu giá, tiền đặt trước tham gia đấu giá sẽ được trả lại trong thời hạn 03 ngày làm việc kể từ ngày tổ chức cuộc đấu giá. Quý khách có chắc chắn rút lại đăng ký tham gia đấu giá không?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Đồng ý",
          cancelButtonText: "Hủy"
        })
        .then(result => {
          if (result.value) {
            Auction.removeRegister(this.id, this.currentUser.id).then(
              ({ data }) => {
                if (data.Message && data.Message != "") {
                  this.$swal.fire({
                    title: "Lỗi",
                    text: data.Message,
                    icon: "error",
                    showCancelButton: false,
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Đồng ý"
                  });
                } else {
                  this.isRegister = false;
                  this.$swal.fire({
                    title: "Thành Công!",
                    text: "",
                    icon: "success",
                    showCancelButton: false,
                    confirmButtonText: "Đồng ý"
                  });
                  location.reload();
                }
              }
            );
          }
        });
    },
    checkRegister() {
      if (this.isAuthenticated) {
        Auction.checkRegister(this.currentUser.id, this.id).then(({ data }) => {
          if (data.Data == 2) this.isRegister = true;
          else if (data.Data == 1) this.isWatting = true;
          else if (data.Data == 3) this.isRejected = true;
        });
      }
    },
    getTime() {
      if (this.detail.KetThuc) {
        if (
          this.currentTime >=
          new Date(this.detail.KetThuc).getTime() + 7 * 3600000
        ) {
          this.status = 4;
          return;
        }

        if (
          this.currentTime <
          new Date(this.detail.HanDangKyBatDau).getTime() + 7 * 3600000
        ) {
          this.status = 0;
          return;
        }
        if (
          this.currentTime <
          new Date(this.detail.HanDangKyKetThuc).getTime() + 7 * 3600000
        ) {
          this.status = 1;
          return;
        }

        if (
          this.currentTime >=
            new Date(this.detail.HanDangKyKetThuc).getTime() + 7 * 3600000 &&
          this.currentTime <
            new Date(this.detail.BatDau).getTime() + 7 * 3600000
        ) {
          this.status = 2;
          return;
        }
        this.status = 3;
      }
    },
    registerAuction() {
      var body = {
        userId: this.currentUser.id,
        lichDauGiaId: this.id,
        soTienDaNop: 0,
        giaoDichId: 0,
        phieuThuId: 0,
        loaiGiaoDichId: 2,
        SoTaiKhoan: this.bank.number,
        NganHang: this.bank.name,
        ChuTaiKhoan: this.bank.user,
        XemHienTrangTaiSan: Number(this.picked)
      };
      this.isWatting = true;
      this.isRegister = false;
      this.$modal.hide("modal-register-auction");

      Auction.register(body).then(({ data }) => {
        if (data.Message && data.Message != "") {
          this.$swal.fire({
            title: "Lỗi?",
            text: data.Message,
            icon: "error",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Đồng ý"
          });
          return "";
        }
        this.$swal.fire({
          title: "Thành công!",
          text:
            "Quý khách vui lòng đọc và thực hiện theo hướng dẫn tại email để hoàn thiện thủ tục đăng ký tham gia đấu giá",
          icon: "success",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Đồng ý"
        });
      });
    },
    getDetail() {
      Auction.getDetail(this.id).then(({ data }) => {
        this.detail = data.Data;
        this.getTime();
      });
    },

    dochangchuc(so, daydu) {
      var chuoi = "";
      let chuc = Math.floor(so / 10);
      let donvi = so % 10;
      if (chuc > 1) {
        chuoi = " " + mangso[chuc] + " mươi";
        if (donvi == 1) {
          chuoi += " mốt";
        }
      } else if (chuc == 1) {
        chuoi = " mười";
        if (donvi == 1) {
          chuoi += " một";
        }
      } else if (daydu && donvi > 0) {
        chuoi = " lẻ";
      }
      if (donvi == 5 && chuc > 1) {
        chuoi += " lăm";
      } else if (donvi > 1 || (donvi == 1 && chuc == 0)) {
        chuoi += " " + mangso[donvi];
      }
      return chuoi;
    },
    docblock(so, daydu) {
      var chuoi = "";
      let tram = Math.floor(so / 100);
      so = so % 100;
      if (daydu || tram > 0) {
        chuoi = " " + mangso[tram] + " trăm";
        chuoi += this.dochangchuc(so, true);
      } else {
        chuoi = this.dochangchuc(so, false);
      }
      return chuoi;
    },
    dochangtrieu(so, daydu) {
      var chuoi = "";
      let trieu = Math.floor(so / 1000000);
      so = so % 1000000;
      if (trieu > 0) {
        chuoi = this.docblock(trieu, daydu) + " triệu";
        daydu = true;
      }
      let nghin = Math.floor(so / 1000);
      so = so % 1000;
      if (nghin > 0) {
        chuoi += this.docblock(nghin, daydu) + " nghìn";
        daydu = true;
      }
      if (so > 0) {
        chuoi += this.docblock(so, daydu);
      }
      return chuoi;
    },
    docso(so) {
      if (so == 0) return mangso[0];
      var chuoi = "",
        hauto = "";
      do {
        let ty = so % 1000000000;
        so = Math.floor(so / 1000000000);
        if (so > 0) {
          chuoi = this.dochangtrieu(ty, true) + hauto + chuoi;
        } else {
          chuoi = this.dochangtrieu(ty, false) + hauto + chuoi;
        }
        hauto = " tỷ";
      } while (so > 0);
      return chuoi;
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/ProductDetail.vue